import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import Profile from '.';
import { useEffect, useState, useLayoutEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { TransitionProps } from '@mui/material/transitions';
import useGetParameter from "../../hooks/useGetParameter";
import { GET_PARAMS } from "../../const/router";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});


export type ProfileModalProps = {
    memberCode: number;
}


const ProfilePopup = ({ isOpened }: any) => {
    const history = useHistory();
    const queryProfileMemberCode = useGetParameter(GET_PARAMS.memberCode);
    const [memberCode, setMemberCode] = useState<number>(
        Number(queryProfileMemberCode)
    );

    useEffect(() => {
        if (queryProfileMemberCode) {
            setMemberCode(Number(queryProfileMemberCode));
        }
    }, [queryProfileMemberCode]);



    return (
        <>
            <div>
                <Dialog
                    fullScreen
                    TransitionComponent={Transition}
                    open={isOpened}
                    disableEscapeKeyDown={true}
                    onClose={() => history.goBack()}

                >
                    <Profile memberCode={memberCode} />
                </Dialog>
            </div>
        </>


    )
}


export default ProfilePopup;